import styles from './technology.module.css'

export default function Technology({ img, name }) {
  return (
    <>
      <div className={styles.technology}>
        <img
          src={img}
          alt={`Imagem da tecnologia ${name}`}
          className={styles.img}
        ></img>
      </div>
    </>
  )
}
